import React from 'react';
import classes from "./button.module.css";

const Button = ({children, click, active, highlight}) => {
    const cls = highlight ? classes.highlight : (active ? classes._ : classes.__)
    return (
        <div className={cls} onClick={click}>
            {children}
        </div>
    );
};

export default Button;